import React from 'react';
import {
  MailOutlined,
  InfoCircleOutlined,
  ExclamationCircleOutlined,
  AppstoreOutlined,
  ClockCircleOutlined,
  FileDoneOutlined,
  InboxOutlined,
} from '@ant-design/icons';
import { IntlShape } from 'react-intl';

export type ReferenceFilter =
  | 'ALL'
  | 'GEN'
  | 'INFO'
  | 'RESULT'
  | 'DEADLINE'
  | 'IMPORTANT';

export interface MessageTypeConfig {
  key: ReferenceFilter;
  labelId: string;
  icon: React.ReactNode;
  color: string;
}

export const MESSAGE_TYPE_CONFIG: MessageTypeConfig[] = [
  {
    key: 'ALL',
    labelId: 'instant-msg-reference-all',
    icon: <InboxOutlined />,
    color: '#131515',
  },
  {
    key: 'GEN',
    labelId: 'instant-msg-general-message',
    icon: <MailOutlined />,
    color: '#1890ff', // Blue
  },
  {
    key: 'INFO',
    labelId: 'instant-msg-information',
    icon: <InfoCircleOutlined />,
    color: '#faad14', // Orange/Yellow
  },
  {
    key: 'IMPORTANT',
    labelId: 'instant-msg-important',
    icon: <ExclamationCircleOutlined />,
    color: '#ff4d4f', // Red
  },
  {
    key: 'RESULT',
    labelId: 'instant-msg-result',
    icon: <FileDoneOutlined />,
    color: '#52c41a', // Green
  },
  {
    key: 'DEADLINE',
    labelId: 'instant-msg-deadline',
    icon: <ClockCircleOutlined />,
    color: 'gray',
  },
];
/**
 * Helper to render the option content: [Icon - Label - Count]
 */
export const renderMessageTypeOption = (
  config: MessageTypeConfig,
  intl: IntlShape,
  count?: number
) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span style={{ color: config.color, display: 'flex' }}>
        {config.icon}
      </span>
      <span>{intl.formatMessage({ id: config.labelId })}</span>
    </div>
    {count !== undefined && (
      <span style={{ fontSize: '12px', opacity: 0.5, marginLeft: '8px' }}>
        ({count})
      </span>
    )}
  </div>
);
